import {Activity, ActivityType} from '../activity';
import {Observable} from 'rxjs';
import {ActivityPropertyDataType} from '../enumerations/activity-property-data-type';
import {LazyDialogService} from './lazy-dialog.service';

export class AddDelayActivity extends Activity {
  public ActivityExecutionCondition: string;
  public TimeoutDuration: string;

  constructor(activityNode: any, lazyDialogService: LazyDialogService) {
    super(lazyDialogService, ActivityType.AddDelay);
    this._properties['ActivityExecutionCondition'] = ActivityPropertyDataType.STRING;
    this._properties['TimeoutDuration'] = ActivityPropertyDataType.STRING;
    this.parse(activityNode);
  }

  openDialog(): Observable<any> {
    return this.openDialogLazy('add-delay', this.dialogConfig);
  }
}
